// Imports
import Swiper from 'swiper';
import { A11y, Keyboard, Navigation } from 'swiper/modules';

export default class Carousels {
    constructor() {
        this.carousels = document.querySelectorAll('[data-carousel]');

        this.init();
    }

    init() {
        this.carousels.forEach((carousel) => {
            const swiperElement = carousel.querySelector('.swiper');
            if (!swiperElement) return;

            const swiper = new Swiper(swiperElement, {
                grabCursor: true,
                loop: false,
                modules: [A11y, Keyboard, Navigation],
                navigation: {
                    nextEl: carousel.querySelector('.swiper-button-next'),
                    prevEl: carousel.querySelector('.swiper-button-prev'),
                },
                slidesPerView: 'auto',
                spaceBetween: 64,
                speed: 1000,
                watchOverflow: true,
                // breakpoints: {
                //     640: {
                //         slidesPerView: 1.3,
                //     },
                //     1024: {
                //         slidesPerView: 1.514,
                //         spaceBetween: 64,
                //     },
                // },
            });

            if (carousel.classList.contains('carousel-key-locations')) {
                this.positionMediaNavigation(carousel, swiper);
            }
        });
    }

    positionMediaNavigation(carousel, swiper) {
        const updatePosition = () => {
            const media = swiper.slides[swiper.activeIndex]?.querySelector('[data-carousel-media]');
            const height = media?.offsetHeight ?? 0;

            carousel.classList.toggle('carousel-navigation-on-media', height > 0);
            carousel.style.setProperty('--carousel-media-height', `${height}px`);
        };

        const observer = new ResizeObserver(updatePosition);
        carousel.querySelectorAll('[data-carousel-media]').forEach((media) => observer.observe(media));
        swiper.on('slideChange', updatePosition);
        swiper.on('resize', updatePosition);
        swiper.on('destroy', () => observer.disconnect());
        updatePosition();
    }
}
